import ActionRow from '@shared/components/core/row/ActionRow';
import { obscureString } from '@shared/hooks/helpers/ObscureText';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

interface IProjectDeviceTypeActionProps {
    deviceTypeId: string;
    title: string;
}

export default function DeviceTypeAction({ deviceTypeId, title }: IProjectDeviceTypeActionProps) {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const handleNavigate = () => {
        navigate(`device/${deviceTypeId}`);
    };

    if (!deviceTypeId || !title) return null;
    return (
        <ActionRow
            iconSize={24}
            title={title}
            description={t('common:organization.projects.deviceType.id') + ': ' + obscureString(deviceTypeId)}
            onClick={handleNavigate}
        />
    );
}
